module.exports = __webpack_public_path__ + "static/media/indieFilm.11abf9e5.svg";